var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.395 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26127",
    d: "M32 58.767a1.2 1.2 0 1 1-1.2-1.2 1.2 1.2 0 0 1 1.2 1.2zm-8.4-1.2a1.2 1.2 0 1 0 1.2 1.2 1.2 1.2 0 0 0-1.2-1.2zm14.8 2.4v2.4a1.6 1.6 0 0 1-1.6 1.6H17.6a1.6 1.6 0 0 1-1.6-1.6v-2.288a11.336 11.336 0 0 1 3.539-8.239l-2.505-2.505a.8.8 0 0 1 1.131-1.135l2.615 2.615a11.141 11.141 0 0 1 12.853-.015l2.6-2.6a.8.8 0 1 1 1.132 1.132l-2.486 2.486c.075.071.15.143.224.217a11.123 11.123 0 0 1 3.297 7.931zm-1.6 0a9.6 9.6 0 0 0-9.6-9.6h-.034a9.672 9.672 0 0 0-9.566 9.712v2.287h19.2z",
    transform: "translate(-16 -47.966)",
    style: {
      fill: "#3fd986"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.2b066de4385d9f35ce120c03b798a550.svg";
export { ForwardRef as ReactComponent };